function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from "react";
import { Radio, Form, Button, Divider, Checkbox, Image, message, QRCode, Input, Select, Alert, Space, Modal, Col as AntCol, Row as AntRow, notification } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import PrescriptionList from "../pieces/PrescriptionList";
import { NodePlusFill, GeoAltFill, TelephoneFill, EnvelopeAtFill, Globe } from "react-bootstrap-icons";
import Moment from "react-moment";
import Footer from "../pieces/Footer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var confirm = Modal.confirm;
var flag = false;
var NewPharmacyPrescription = function NewPharmacyPrescription(_ref) {
  var _ref$patient = _ref.patient,
    patient = _ref$patient === void 0 ? null : _ref$patient,
    _ref$check = _ref.check,
    check = _ref$check === void 0 ? null : _ref$check,
    handler = _ref.handler;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    drugsOptions = _useState2[0],
    setDrugsOptions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptOptions = _useState4[0],
    setDeptOptions = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    deptData = _useState6[0],
    setDeptData = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormProcessing = _useState8[0],
    setIsFormProcessing = _useState8[1];
  var _useState9 = useState(""),
    _useState0 = _slicedToArray(_useState9, 2),
    errorMessage = _useState0[0],
    setErrorMessage = _useState0[1];
  var _useState1 = useState(""),
    _useState10 = _slicedToArray(_useState1, 2),
    successMessage = _useState10[0],
    setSuccessMessage = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    itemsData = _useState12[0],
    setItemsData = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemsOptionsData = _useState14[0],
    setItemsOptionsData = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    drugList = _useState16[0],
    setDrugList = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    bilans = _useState18[0],
    setBilans = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    quantities = _useState20[0],
    setQuantities = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    position = _useState22[0],
    setPosition = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedProductId = _useState24[0],
    setSelectedProductId = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    npLabel = _useState26[0],
    setNpLabel = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    dataChanged = _useState28[0],
    setDataChanged = _useState28[1];
  var inputRef = useRef(null);
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var addItem = function addItem(e) {
    e.preventDefault();
    setTimeout(function () {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }, 0);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'ajout de ", npLabel]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "additemtodept", {
          label: npLabel,
          dcode: "PHA",
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setDataChanged(true);
            setNpLabel("");
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var onNewProductChange = function onNewProductChange(e) {
    setNpLabel(e.target.value);
  };
  var dosageArray = [{
    label: "1 - 1 - 1",
    value: "1 - 1 - 1"
  }, {
    label: "1 - 0 - 0",
    value: "1 - 0 - 0"
  }, {
    label: "1 - 0 - 1",
    value: "1 - 0 - 1"
  }, {
    label: "1/2 - 1/2 - 1/2",
    value: "1/2 - 1/2 - 1/2"
  }, {
    label: "À jeun",
    value: "À jeun"
  }, {
    label: "Après les collations ou avec du lait",
    value: "Après les collations ou avec du lait"
  }, {
    label: "Après les repas ou avec du lait",
    value: "Après les repas ou avec du lait"
  }, {
    label: "Deux au coucher avec de l'eau",
    value: "Deux au coucher avec de l'eau"
  }];
  var onFinish = function onFinish() {
    setIsFormProcessing(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append("prescriptions", bilans);
    formData.append("quantities", quantities.join(","));
    if (check == null) formData.append("medical_check_id", null);else formData.append("medical_check_id", check.id);
    formData.append("user_id", Common.currentUser.id);
    formData.append("dcode", "PHA");
    axios.post(Common.baseApiUrl + "setprescriptions", formData).then(function (response) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      if (response.data.status == 200) {
        handler();
        notification.success({
          message: "Ok!",
          description: "Prescriptions effectuées avec succès"
        });
        setSuccessMessage("Prescriptions effectuées avec succès");
        var content = document.getElementById("prtdiv");
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  var onAddPrescription = function onAddPrescription(values) {
    var item = drugsOptions.filter(function (o) {
      return o.value == values.bilan;
    })[0];
    if (drugList.filter(function (i) {
      return i.id == values.bilan;
    }).length > 0) {
      var extElementQuant = drugList.filter(function (i) {
        return i.id == item.value;
      })[0].quantity;
      setDrugList(drugList.filter(function (i) {
        return i.id != item.value;
      }));
      setDrugList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.value,
          label: item.label,
          quantity: extElementQuant + 1,
          comment: values.comment,
          position: position
        }]);
      });
    } else {
      setDrugList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.value,
          label: item.label,
          quantity: 1,
          comment: values.comment,
          position: position + 1
        }]);
      });
      setPosition(function (prev) {
        return prev + 1;
      });
    }
    setBilans(function (prev) {
      return [].concat(_toConsumableArray(prev), [values.bilan]);
    });
    drugList.forEach(function (i) {
      setQuantities(function (prev) {
        return [].concat(_toConsumableArray(prev), [i.quantity]);
      });
    });
  };
  var handleDeptChange = function handleDeptChange(e) {
    setItemsOptionsData([]);
    var ar = deptData.filter(function (d) {
      return d.id.toString() == e.target.value;
    });
    if (ar.length > 0) {
      ar.forEach(function (d) {
        d.services.forEach(function (s) {
          setItemsOptionsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [s]);
          });
        });
      });
    }
  };
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getservicetree/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setDrugList([]);
        setDrugsOptions([]);
        var ars = response.data.services.filter(function (d) {
          return d.dcode == 'PHA';
        });
        ars.forEach(function (d) {
          setItemsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [d]);
          });
          d.business_account_medical_items.forEach(function (m_i) {
            setDrugsOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                label: m_i.label,
                value: m_i.id
              }]);
            });
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setQuantities([]);
    drugList.forEach(function (i) {
      setQuantities(function (prev) {
        return [].concat(_toConsumableArray(prev), [i.quantity]);
      });
    });
  }, [drugList]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex"
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              flex: "30%"
            },
            children: Common.account == 'undefined' && Common.account.logo == null ? /*#__PURE__*/_jsx(Image, {
              preview: false,
              width: "100%",
              src: "/drawables/cl.png"
            }) : /*#__PURE__*/_jsx(Image, {
              preview: false,
              width: "100%",
              src: Common.baseUrl + Common.account.logo
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flex: "70%"
            },
            children: /*#__PURE__*/_jsx("h4", {
              style: {
                marginLeft: "14px",
                textAlign: "center",
                marginTop: '40px',
                color: "#EEE",
                padding: "14px",
                background: "#800908",
                borderRadius: "6px"
              },
              children: /*#__PURE__*/_jsx("b", {
                children: " ORDONANCE"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        style: {
          clear: "both"
        },
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", patient.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", patient.firstname + " " + patient.lastname]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PrescriptionList, {
        data: drugList
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(AntRow, {
        children: [/*#__PURE__*/_jsx(AntCol, {
          lg: 8,
          md: 8,
          sm: 9,
          xs: 12,
          children: /*#__PURE__*/_jsx(QRCode, {
            size: 90,
            type: "svg",
            value: "https://cliniqueadmin.com/#/checkprescription/" + check.id.toString()
          })
        }), /*#__PURE__*/_jsx(AntCol, {
          lg: {
            span: 10,
            offset: 6
          },
          md: {
            span: 12,
            offset: 4
          },
          sm: {
            span: 10,
            offset: 6
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              textAlign: "center"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Le Medecin"
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              children: Common.currentUser.firstname + " " + Common.currentUser.lastname
            }), /*#__PURE__*/_jsx("br", {})]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), Common.account != 'undefined' && /*#__PURE__*/_jsxs("div", {
        style: {
          background: "#D8C0C0",
          textAlign: "center",
          padding: "7px",
          borderRadius: "7px",
          color: "#433F3F"
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex"
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flex: "49%"
            },
            children: [/*#__PURE__*/_jsx(GeoAltFill, {
              style: {
                flex: "10%"
              },
              size: 29
            }), /*#__PURE__*/_jsxs("span", {
              style: {
                flex: "90%"
              },
              children: [" Adresse: ", Common.account.address]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flex: "49%"
            },
            children: [/*#__PURE__*/_jsx(TelephoneFill, {
              style: {
                flex: "10%"
              },
              size: 29
            }), /*#__PURE__*/_jsx("span", {
              style: {
                flex: "90%"
              },
              children: Common.account.mobile
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex"
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flex: "49%"
            },
            children: [/*#__PURE__*/_jsx(EnvelopeAtFill, {
              style: {
                flex: "10%"
              },
              size: 29
            }), /*#__PURE__*/_jsxs("span", {
              style: {
                flex: "90%"
              },
              children: [" ", Common.account.email]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flex: "49%"
            },
            children: [/*#__PURE__*/_jsx(Globe, {
              style: {
                flex: "10%"
              },
              size: 29
            }), /*#__PURE__*/_jsx("span", {
              style: {
                flex: "90%"
              },
              children: Common.account.website
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          children: [/*#__PURE__*/_jsxs(Form, {
            layout: "vertical",
            form: form,
            onFinish: onAddPrescription,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "department",
              children: /*#__PURE__*/_jsx(Radio.Group, {
                onChange: handleDeptChange,
                options: deptOptions,
                optionType: "button",
                buttonStyle: "solid"
              })
            }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage,
              banner: true
            }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "success",
              message: successMessage,
              banner: true
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "bilan",
              rules: [{
                required: true,
                message: "Veuillez choisir une option"
              }],
              children: /*#__PURE__*/_jsx(Select, {
                size: "large",
                filterOption: true,
                optionFilterProp: "label",
                allowClear: true,
                showSearch: true,
                placeholder: "Choisir les produits",
                style: {
                  width: '100%'
                },
                options: drugsOptions,
                dropdownRender: function dropdownRender(menu) {
                  return /*#__PURE__*/_jsxs(_Fragment, {
                    children: [menu, /*#__PURE__*/_jsx(Divider, {
                      style: {
                        margin: '8px 0'
                      }
                    }), /*#__PURE__*/_jsxs(Space, {
                      style: {
                        padding: '0 8px 4px'
                      },
                      children: [/*#__PURE__*/_jsx(Input, {
                        placeholder: "Nom du produit",
                        ref: inputRef,
                        value: npLabel,
                        onChange: onNewProductChange,
                        onKeyDown: function onKeyDown(e) {
                          return e.stopPropagation();
                        }
                      }), /*#__PURE__*/_jsx(Button, {
                        type: "text",
                        icon: /*#__PURE__*/_jsx(NodePlusFill, {}),
                        onClick: addItem,
                        children: "AJOUTER"
                      })]
                    })]
                  });
                }
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "comment",
              label: "Posologie",
              children: /*#__PURE__*/_jsx(Select, {
                size: "large",
                filterOption: true,
                optionFilterProp: "label",
                allowClear: true,
                showSearch: true,
                placeholder: "Choisir la posologie",
                style: {
                  width: '100%'
                },
                options: dosageArray
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                disabled: drugsOptions.length == 0,
                htmlType: "submit",
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "AJOUTER"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(PrescriptionList, {
              data: drugList
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                onClick: onFinish,
                disabled: drugList.length == 0,
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "PRESCRIRE"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "link",
                disabled: drugList.length == 0,
                onClick: function onClick() {
                  setDrugList([]);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "EFFACER"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Image, {
            src: "/drawables/ppi.png",
            preview: false,
            width: "90%"
          })
        })]
      })
    })]
  });
};
export default NewPharmacyPrescription;